import { render, staticRenderFns } from "./TableInput.vue?vue&type=template&id=06589d48"
import script from "./TableInput.ts?vue&type=script&lang=ts&external"
export * from "./TableInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports